<div class="row" *ngIf="!showFallbackView">
  <div class="col-sm-12">
    <div class="d-flex flex-row post-header">
      <div class="post-summarize">
      </div>
      <div class="post-kpi header-title">
        <div class="d-flex flex-row flex-auto mb-2">
          <div class="platform-col">
          </div>
          <div class="impression-col">
            <span class="best-performing-header impressions">{{'INFLUENCER.insight.best_performing_exposure.engagement' | translate}}</span>
          </div>
          <div class="reach-col">
            <span class="best-performing-header reach">{{'INFLUENCER.insight.best_performing_exposure.reach' | translate}}</span>
          </div>
          <div class="impact-col">
            <span class="best-performing-header impact">{{'INFLUENCER.insight.best_performing_exposure.impact' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12"
       *ngFor="let platformReach of platformReachs; let i = index; let lastRow = last">
    <div class="best-performing-row" [ngClass]="{'even': i % 2 === 0, 'odd' : i % 2 !== 0, 'customized-border-radius': lastRow}">
      <platform-reach-item [platformReach]="platformReach"></platform-reach-item>
    </div>
  </div>
</div>
<div *ngIf="showFallbackView" class="full-width">
 <print-latest-posts-placeholder></print-latest-posts-placeholder>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/list-platform-reach/list-platform-reach.component.html